import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Navbar, Nav, Dropdown } from "react-bootstrap";

const HeaderLoggedInMobile = ({auth}) => { 
    const [expanded, setExpanded] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const userInitial = auth?.first_name ? auth.first_name.charAt(0).toUpperCase() : null;

    // Loading state navbar
    const navbarStyle = {
        background: 'rgba(255, 255, 255, 0.98)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(10px)'
    };

    // Don't render if auth data isn't loaded yet
    if (!auth || !auth.id) {
        return (
            <div className="d-block d-lg-none">
                <Navbar fixed="top" expand="md" className="navbar-custom" style={navbarStyle}>
                    <Navbar.Brand className="p-0" style={{marginLeft:"10px", marginRight:"10px"}}>
                        <a href="/" style={{color: "#2d3748", textDecoration:"none", fontWeight:"500"}}>
                            Elliot Koss
                        </a>
                    </Navbar.Brand>
                </Navbar>
            </div>
        );
    }

    return (
        <>
        <div className="d-block d-lg-none">
            <Navbar 
                fixed="top" 
                expanded={expanded}
                onToggle={() => setExpanded(!expanded)}
                expand="md" 
                className="navbar-custom" 
                style={navbarStyle}
            >
                <Navbar.Brand className="p-0" style={{marginLeft:"10px", marginRight:"10px"}}>
                    <a href="/" style={{color: "#2d3748", textDecoration:"none", fontWeight:"500"}}>
                        Elliot Koss
                    </a>
                </Navbar.Brand>

                {/* User avatar - always visible */}
                <div className="d-flex align-items-center order-lg-last" style={{ marginRight: '10px' }}>
                    <div ref={dropdownRef}>
                        <Dropdown show={showDropdown} onToggle={() => {}}>
                            <div
                                onClick={() => setShowDropdown(!showDropdown)}
                                style={{
                                    width: '35px',
                                    height: '35px',
                                    borderRadius: '50%',
                                    backgroundColor: '#067100',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    fontSize: '0.9em',
                                }}
                            >
                                {userInitial === null ? <i className="bi bi-person-fill fs-5"></i> : userInitial}
                            </div>

                            <Dropdown.Menu align="end" show={showDropdown} className="custom-dropdown-menu p-0" style={{minWidth:"200px"}}>
                                <Dropdown.Item 
                                    href="/logout" 
                                    className="py-2"
                                    style={{ color:"#dc3545"}}
                                >
                                    Logout
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> 
                    </div>
                </div>

                <Navbar.Toggle 
                    aria-controls="mobile-nav-loggedin" 
                    onClick={() => setExpanded(!expanded)}
                    style={{ 
                        border: 'none',
                        padding: '0.5rem',
                        marginRight: '10px'
                    }}
                />
                
                <Navbar.Collapse id="mobile-nav-loggedin">
                    <Nav className="ms-auto" style={{ padding: '0.5rem 0' }}>
                        <a 
                            href="/dashboard" 
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                padding: "0.75rem 1rem",
                                borderRadius: "0.25rem"
                            }}
                        >
                            <i className="bi bi-speedometer2" style={{ marginRight: "0.5rem" }}></i>
                            Dashboard
                        </a>
                        <a 
                            href="/ai-notes" 
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                padding: "0.75rem 1rem",
                                borderRadius: "0.25rem"
                            }}
                        >
                            AI Notes
                        </a>
                        {auth && auth.role === 'admin' && (
                            <a
                                href="/admin/ai-notes"
                                onClick={() => setExpanded(false)}
                                className="d-flex align-items-center"
                                style={{
                                    color: "#4a5568", 
                                    textDecoration: "none",
                                    fontSize: "1rem", 
                                    fontWeight: "400", 
                                    padding: "0.75rem 1rem",
                                    borderRadius: "0.25rem"
                                }}
                            >
                                Post Notes
                            </a>
                        )}
                        <a 
                            href="/contact" 
                            onClick={() => setExpanded(false)}
                            className="d-flex align-items-center"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                padding: "0.75rem 1rem",
                                borderRadius: "0.25rem"
                            }}
                        >
                            Contact
                        </a>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
        </>
    )
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(HeaderLoggedInMobile);